import Sketch from '@arcgis/core/widgets/Sketch';

export const SKETCH_WIDGET_TITLE = 'sketch-widget';

/**
 * Create and return an instance of the Sketch widget to be added to the map.
 * https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Sketch.html
 * @param {Object} graphicsLayer - the graphics layer associated with the sketch widget.
 * @param {Object} mapView - the map view associated with the sketch widget
 */
export const createSketchWidget = ({ graphicsLayer, mapView }) => {
  return new Sketch({
    // https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Sketch.html#id
    id: SKETCH_WIDGET_TITLE,
    // https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Sketch.html#layer
    layer: graphicsLayer,
    // https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Sketch.html#view
    view: mapView,
    // https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Sketch.html#creationMode
    // creationMode: 'continuous',
  });
};
